export namespace OpenService {
  export enum Formats {
    date = "DD.MM.YYYY",
    time = "HH:mm",
    datetime = "DD.MM.YYYY HH:mm",
    datetimeWithSeconds = "DD.MM.YYYY HH:mm:ss",
    datetimeWithSecondsAndTimezone = "DD.MM.YYYY HH:mm:ss Z",
    timeWithSeconds = "HH:mm:ss",
    timeWithSecondsAndTimezone = "HH:mm:ss Z",
    timeWithTimezone = "HH:mm Z",
    dateWithTimezone = "DD.MM.YYYY Z",
    dateWithTimezoneAndTime = "DD.MM.YYYY HH:mm Z",
    dateWithTimezoneAndTimeAndSeconds = "DD.MM.YYYY HH:mm:ss Z",
    dateWithTimezoneAndTimeAndSecondsAndTimezone = "DD.MM.YYYY HH:mm:ss Z Z",
    dateAsCalendarWeeks = "WW in YYYY",
  }

  /**
   * Configuration keys for the maintenance module.
   * These keys are used to store configuration values in the database in table OD3_Config.
   */
  export enum ConfigKeys {
    closedTicketsLifetime = "OPENSERVICE_CLOSED_TICKET_LIFETIME",
    ticketCreationForm = "OPENSERVICE_CREATE_TICKET_FORM",
    scheduleMetaFields = "OPENSERVICE_SCHEDULE_META_FIELDS",
    sampledataCreated = "OPENSERVICE_SAMPLEDATA_CREATED",
    createTicketOnSchedule = "OPENSERVICE_CREATE_TICKET_ON_SCHEDULE",
  }

  /**
   * Permissions for the maintenance module.
   * Should implement general CRUD permissions.
   * Permissions are registered in the cloud code.
   * This is just a reference to all permissions available.
   */
  export namespace Permissions {
    //Create
    export enum Create {
      ticket = "maintenance:can-create-ticket",
      schedule = "maintenance:can-create-schedule",
      message = "maintenance:can-create-message",
      machinelog_ticket = "maintenance:can-create-machinelog-ticket",
      machinelog_schedule = "maintenance:can-create-machinelog-schedule",
      machinelog_message = "maintenance:can-create-machinelog-message",
    }

    //Retrieve
    export enum Access {
      global = "maintenance:can-access-global",
      monitor = "maintenance:can-access-monitor",
      monitoring = "maintenance:can-access-monitoring",
    }

    //Update
    export enum Update {
      kanban_view = "maintenance:can-update-kanban-view",
    }

    //Delete
    export enum Delete {}
  }
}
